module.exports = __webpack_public_path__ + "img/all-city.png";